module.exports = __webpack_public_path__ + "static/media/track-sonoma.75219a42.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-sonoma.png
// module id = 1038
// module chunks = 0